var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClockGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 11.667H8a.833.833 0 01-.833-.833v-2.5a.833.833 0 111.666 0v1.667H10.5a.833.833 0 110 1.666zM8.823 3.382c.002-.017.01-.03.01-.048v-.833h.834a.833.833 0 100-1.667H6.333a.833.833 0 100 1.667h.834v.833c0 .017.008.03.01.048C3.427 3.794.5 6.977.5 10.834c0 4.136 3.365 7.5 7.5 7.5s7.5-3.364 7.5-7.5c0-3.857-2.928-7.04-6.677-7.452z",
    fill: "#C4C4C4"
  })));
}

export default SvgClockGray;